import { render, staticRenderFns } from "./consumeConfirmAction.vue?vue&type=template&id=3878e0da&scoped=true"
import script from "./consumeConfirmAction.vue?vue&type=script&lang=js"
export * from "./consumeConfirmAction.vue?vue&type=script&lang=js"
import style0 from "./consumeConfirmAction.vue?vue&type=style&index=0&id=3878e0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878e0da",
  null
  
)

export default component.exports